import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MoreHorizontal } from "lucide-react";
import Button from "../../../../../components/shared/Button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../../../../components/ui/dropdown-menu";
import { useScheduleContext } from "../../hooks/context/useScheduleContext";
import { usePermissions } from "../../hooks/usePermissions";

function BulkActions({ openAssignModal, openDeleteModal }: any) {
    const { t } = useTranslation();
    const { unassignedEvents, selectedUnassignedEvents, dispatch } = useScheduleContext();
    const {
        canCreateUnassignedShift,
        canDeleteUnassignedShift,
        canEditUnassignedShift,
        canAssign
    } = usePermissions();

    const selectAll = useCallback(() => {
        const payload = (
            selectedUnassignedEvents?.length === 0 ||
            (
                selectedUnassignedEvents?.length !== unassignedEvents?.length &&
                selectedUnassignedEvents?.length > 0
            )
        )
            ? unassignedEvents
            : [];
        dispatch({ type: "select-unassigned-events", payload });
    }, [dispatch, selectedUnassignedEvents, unassignedEvents]);

    const create = useCallback(() => {
        dispatch({
            type: "selected-cell-or-event",
            payload: { isUnassignedShift: true, isCreating: true }
        });
        dispatch({ type: "select-unassigned-events", payload: [] });
    }, [dispatch]);

    return (canCreateUnassignedShift || canDeleteUnassignedShift || canAssign || canEditUnassignedShift) && (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost">
                    <MoreHorizontal className="tw-cursor-pointer" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="tw-p-2">
                <DropdownMenuItem
                    className="tw-cursor-pointer"
                    onClick={selectAll}
                    disabled={unassignedEvents?.length === 0 || !(canEditUnassignedShift && canDeleteUnassignedShift)}
                >
                    {selectedUnassignedEvents?.length === unassignedEvents?.length
                        ? t("deselect-all")
                        : t("select-all")}
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="tw-cursor-pointer"
                    onClick={create}
                    disabled={!canCreateUnassignedShift}
                >
                    {t("create")}
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="tw-cursor-pointer"
                    onClick={() => openAssignModal({
                        unassignedEvents: selectedUnassignedEvents?.length > 0
                            ? selectedUnassignedEvents
                            : unassignedEvents
                    })}
                    disabled={unassignedEvents?.length !== 1 || !canAssign || selectedUnassignedEvents?.length !== 1}
                >
                    {t("assign")}
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="tw-cursor-pointer"
                    onClick={() => openDeleteModal({
                        type: "bulk-unassign",
                        ids: (selectedUnassignedEvents?.length > 0
                            ? selectedUnassignedEvents
                            : unassignedEvents)?.map((event: any) => event.id)
                    })}
                    disabled={unassignedEvents?.length === 0 || !canDeleteUnassignedShift}
                >
                    {t("delete")}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default BulkActions;
